export function dateFormat(date) {
    const loggingDate =
        date.getFullYear() +
        "-" +
        numformat(date.getMonth() + 1) +
        "-" +
        numformat(date.getDate());

    return loggingDate;
}

const numformat = (num) => {
    let formattedNum = "";
    if (num < 10) formattedNum = "0" + num;
    else formattedNum = "" + num;

    return formattedNum;
};
